module.exports = __webpack_public_path__ + "img/weronika-ratkowska@2x.e02ab4dd.jpg";